export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";